import React from 'react'
import KvkService from 'services/kvk.service'
import AsyncResourceSelect from './AsyncResourceSelect'
import toastService from 'services/toast.service'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding } from '@fortawesome/pro-solid-svg-icons'
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons'

export interface ICompanyNameProps {
	value: any | string
	validator: any
	changeData: Function
	filterOptions?: Function
	valueInitFn?: Function
	onChange?: Function
	isNew?: Boolean
}

const CompanyName = (props: ICompanyNameProps) => {
	const { value, validator, changeData, isNew = true } = props

	const formatOptionLabel = (option, context) => {
		if (context == 'value') {
			return option?.__isNew__ ? option?.name : option?.attributes?.companyName
		} else {
			if (option?.__isNew__) {
				return <div>{option?.name}</div>
			} else {
				return (
					<div>
						<div className="py-1">{option.attributes.companyName}</div>
						<div className="text-gray-500 text-sm py-0.5">
							<span className="inline-block ml-1 w-6">
								<FontAwesomeIcon icon={faEnvelope} />
							</span>
							Kvk: {option.attributes.kvknr} ({option.attributes.companyType})
						</div>
						<div className="text-gray-500 text-sm py-0.5">
							{option.attributes?.streetName && (
								<>
									<span className="inline-block ml-1 w-6">
										<FontAwesomeIcon icon={faBuilding} />
									</span>
									{option.attributes?.streetName}, {option.attributes?.cityName}
								</>
							)}
						</div>
					</div>
				)
			}
		}
	}
	const newOptionLabel = (value, label) => {
		return {
			id: value,
			name: label,
			__isNew__: true,
		}
	}

	const onChange = (res) => {
		if (res?.target) {
			changeData({ name: res.target.value })
			return
		}
		// empty fields if new company is created
		let companyData: any = {
			cityName: '',
			websiteUrl: '',
			description: '',
			employeeCount: '',
			foundedAt: '',
			houseNumber: '',
			houseNumberExtension: '',
			name: '',
			postalCode: '',
			streetName: '',
		}

		if (!res) {
			changeData(companyData)
		}
		if (res?.__isNew__) {
			companyData.name = res.id
			changeData(companyData)
			validator.showMessageFor('name')
		} else if (res?.id) {
			KvkService.getKvkDetail(res.id, {})
				.then((res) => {
					if (res?.kvk) {
						let id = Object.keys(res.kvk)[0]
						for (let key in companyData) {
							companyData[key] = res.kvk[id].attributes[key] ?? ''
						}
						companyData['foundedAt'] = moment(
							res.kvk[id].attributes['foundedAt'],
							'YYYY-MM-DD'
						).toDate()
					}
					changeData(companyData)
				})
				.catch((error) => {
					toastService.showError('Error retrieving kvk data!')
					console.log(error)
				})
		}
	}

	if (!isNew) {
		return (
			<input
				className="w-full"
				name="name"
				value={value}
				onChange={onChange}
				onBlur={() => validator.showMessageFor('name')}
				id="name"
				type="text"
				placeholder="Company name"
			/>
		)
	} else {
		return (
			<AsyncResourceSelect
				className={'lineBetweenOptions'}
				type="AsyncSelectCreatable"
				formatCreateLabel={(val) => 'Use: ' + val}
				createOptionPosition={'first'}
				instanceId="name"
				name="name"
				placeholder={'Company name'}
				resourceKey={'kvk'}
				resourceAttribute={'label'}
				resourceProvider={KvkService.getKvkSearch}
				formatOptionLabel={formatOptionLabel}
				getNewOptionData={newOptionLabel}
				debounceTime={300}
				debounceMinimumCharacters={1}
				classNamePrefix="react-select"
				onChange={onChange}
				onBlur={() => validator.showMessageFor('name')}
			/>
		)
	}
}

CompanyName.isFormable = true

export default CompanyName
